/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_MetadataInputs */



/**
* | output |
* | --- |
* | "Importing project metadata..." |
*
* @param {Load_Project_File_Status_MetadataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_metadata = /** @type {((inputs?: Load_Project_File_Status_MetadataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_MetadataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des metadonnees du projet...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektmetadaten werden importiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione dei metadati del progetto...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт метаданных проекта...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando metadatos del proyecto...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入项目元数据...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト メタデータをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट मेटाडेटा आयात किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando metadados do projeto...")
	return /** @type {LocalizedString} */ ("Importing project metadata...")
});